/**
 * Controls whether we enable updated free shipping threshold UI for carthttps:www.notion.so/faire/Preorder-logic-for-GS-and-FST-1e9e2a863a9a45e08a3b956582591e62
 */
export const ENABLE_UPDATED_FREE_SHIPPING_THRESHOLDS_UI_FOR_CART_241008 = 'ENABLE_UPDATED_FREE_SHIPPING_THRESHOLDS_UI_FOR_CART_241008';
